import {
  GetOrderIntentEstimateRequestForPartnerOrderReview,
  PlacePartnerOrderProxyParams,
} from '@atlassian/cssxp-typescommon';
import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';
import { OrderBillEstimateResponseDto, OrderResponseDto } from '@atlassian/commerce-ccp-gateway-client';

const client = createAxiosClient({ baseURL: '/api/1/oms' }, ServiceProxyMap.ANS);

// These proxies are specific to PPC

export const getOrderEstimateForPartnerOrderReview = async (
  requestPayload: GetOrderIntentEstimateRequestForPartnerOrderReview
): Promise<OrderBillEstimateResponseDto> => {
  const response = await client.post('/getBillEstimateForOrderReview', requestPayload);
  return response.data;
};

export const placePartnerOrder = async (requestPayload: PlacePartnerOrderProxyParams): Promise<OrderResponseDto> => {
  const response = await client.post('/placePartnerOrder', requestPayload);
  return response.data;
};
